var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"prebet-match__odd",class:{ selected: _vm.amISelected },on:{"click":function($event){return _vm.addToBetslip()}}},[_c('span',{staticClass:"prebet-match__odd__odd-value bold"},[_vm._v(_vm._s(_vm.odd.odd_value || "-"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }